<template>
  <div class="person">
    <div class="item-del" @click="deleteAddr">删除</div>
    <div
      class="item"
      :style="style"
      ref="dg"
      :class="thisClass"
      @click="toggleChecked"
      @touchstart="ts($event)"
      @touchend="te($event)"
      @touchmove="tm($event)"
      @touchcancel="tc($event)"
    >
      <div class="l">
        <input type="checkbox" v-model="item.isChecked" />
        <i class="iconfont icon-gou"></i>
      </div>
      <div class="m">
        <div class="info">
          <span class="field">{{ item.name }}</span>
          <span>{{ item.mobile | maskMobile }}</span>
        </div>
        <div class="info">
          <span class="field">身份证</span>
          <span>{{ item.card | maskCard }}</span>
        </div>
      </div>
      <div class="r">
        <!-- <a href="#" class="btn" @click.prevent.stop="modify">
          <i></i><span>修改</span>
        </a> -->
        <a href="#" class="btn-edit" @click.prevent.stop="modify">编辑</a>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/plugins/http'
import { Msgbox } from 'kf-component-vue'

export default {
  head() {
    return {
      title: this.title
    }
  },
  created() {},
  mounted() {
    this.$$loading(false)
    this.setThreshold()
  },
  data() {
    return {
      title: '选择游客',
      bx: 0,
      sx: 0,
      dx: 0,
      isTs: false,
      threshold: -60
    }
  },
  methods: {
    deleteAddr() {
      Msgbox({
        title: '提示',
        message: '删除这个游客？',
        showCancelButton: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'confirm',
        action: msgbox => {
          this.doDelete()
          this.dx = this.bx = 0
        },
        cancel: msgbox => {}
      })
    },
    async doDelete() {
      const { uid, skey } = await this.$$ensureLogin()
      if (!uid || !skey) return 1

      const qs = this.$$queryString.stringify({
        uid,
        skey,
        tpid: this.item.tpid
      })
      const url = `//soperationapi.cekid.com/soperation-api/traveling/delTravelingPerson.do?${qs}`
      http.get(url).then(res => {
        if (res.errno === 505) {
          this.$$login()
        } else if (res.errno !== 0) {
          this.$$toast(res.errmsg)
        } else {
          this.$emit('removed', this.item.tpid)
        }
      })
    },
    modify() {
      this.$emit('modify', this.item)
    },
    toggleChecked() {
      this.$emit('toggleCheck', this.item)
    },
    setThreshold() {
      const base = 122 / 100
      const fs = parseInt(document.documentElement.style.fontSize, 10)
      this.threshold = base * fs * -1
    },
    ts(e) {
      const t = e.targetTouches[0]
      this.sx = t.pageX
    },
    tm(e) {
      const t = e.targetTouches[0]
      const tmp = t.pageX - this.sx
      this.dx = tmp + this.bx
    },
    te(e) {
      this.isTs = true
      setTimeout(() => {
        this.isTs = false
      }, 300)

      if (this.dx < this.threshold) {
        this.bx = this.threshold
      } else {
        this.bx = 0
      }
      this.dx = this.bx
    },
    tc(e) {
      this.te(e)
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    style() {
      return {
        transform: `translate3d(${this.dx}px,0,0)`
      }
    },
    thisClass() {
      return {
        ts: this.isTs
      }
    }
  },
  components: { Msgbox },
  filters: {
    maskMobile(str) {
      return `${str.substr(0, 3)}****${str.substr(-4)}`
    },
    maskCard(str) {
      return `${str.substr(0, 4)}**********${str.substr(-4)}`
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.item-del {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  background: #ff4b4b;
  margin-top: rem(2px);
  margin-bottom: rem(2px);
  color: #fff;
  font-size: rem(30px);
  width: rem(122px);
  display: flex;
  justify-content: center;
  align-items: center;
}
.item {
  position: relative;
  z-index: 1;
  background: #fff;
  height: rem(162px);
  display: flex;
  &.ts {
    transition: all 0.3s ease;
  }

  .l {
    width: rem(102px);
    flex: 0 0 rem(102px);
    display: flex;
    justify-content: center;
    align-items: center;

    input {
      display: none;
    }
    i {
      display: inline-block;
      width: rem(36px);
      height: rem(36px);
      border: 1px solid #dddddd;
      border-radius: 50%;
      text-align: center;
      font-size: rem(18px);
      line-height: rem(36px);
      color: transparent;
    }
    input[type='checkbox']:checked + i {
      background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
      border: none;
      color: #fff;
      height: rem(40px);
      width: rem(40px);
      font-size: rem(32px);
    }
  }
  .m {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      span {
        font-size: rem(32px);
        color: #262626;
      }

      .field {
        font-size: rem(32px);
        color: #666666;
        width: 25%;
        display: inline-block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      &:last-child {
        margin-top: rem(12px);
      }
    }
  }
  .r {
    width: rem(122px);
    flex: 0 0 rem(122px);
    height: inherit; // hack for legacy andriod
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      i {
        display: inline-block;
        width: rem(36px);
        height: rem(36px);
        background: url('~assets/images/order/btn_edit.png') no-repeat
          center/contain;
        margin-right: rem(10px);
      }
      span {
        font-size: rem(26px);
        color: #666666;
      }
      i,
      span {
        display: block;
        vertical-align: middle;
      }
    }

    .btn-edit {
      display: block;
      font-size: rem(26px);
      color: #348be6;
      height: rem(80px);
      width: rem(80px);
      text-align: center;
      line-height: rem(80px);
    }
  }
}
</style>
